export enum UserTitle {
  Ms = 'ms',
  Mr = 'mr',
  Diverse = 'diverse',
}

export const isUserTitle = (value: string): value is UserTitle =>
  Object.values(UserTitle).includes(value as UserTitle);
